import { useContext, useCallback } from "react";

import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import get from "@beeldit/core/services/get";
import { TenantAndCommerceContext } from "@main/contexts/TenantAndCommerceContext";
import { applyCommerceTheme } from "@main/commerces/utils/applyCommerceTheme";

function useGetConfig() {
  // const errorHandler = useErrorHandler();
  const { setCommerce } = useContext(TenantAndCommerceContext);

  const fetchConfig = useCallback(
    (
      id: any,
      onSuccess: any = (data: any) => {
        return data;
      }
    ) => {
      get("commerces", id, "?relations=invoiceConfiguration")
        .then((response: any) => {
          let data = response.data;
          data = onSuccess(response.data);
          setCommerce(data);
          
          // Aplicar tema del comercio usando su ID
          applyCommerceTheme(id);
        })
        .catch((error: any) => {
          // errorHandler(error); // TODO - Lo he quitado porque hay un fallo que hace que redirija al login
        });
    },
    [setCommerce]
  );

  return fetchConfig;
}

export default useGetConfig;
